<div class="dialog-body">

  <div class="dialog-content">
    <div class="parameter-section">
      <h3>{{'jsoncomponent.identification'|translateTA}}</h3>

      <div class="tem-field field-md">
        <span class="tem-field-label">{{'jsoncomponent.integrationName'|translateTA}}</span>
        <input nz-input [(ngModel)]="configName" [placeholder]="'jsoncomponent.integrationNamePlaceholder'|translateTA" />
      </div>
    </div>

    <div *ngIf="data?.entity?.IDRULE" class="parameter-section">
      <h3>{{'jsoncomponent.configImage'|translateTA}}</h3>

      <div class="image-row">
        <img [src]="imagePreview" class="config-image" alt="" />
        <button nz-button nzType="primary" type="button" (click)="triggerImageUpload()">
          <nz-icon nzType="upload" />{{'jsoncomponent.selectImage'|translateTA}}
        </button>
        <input type="file" #fileInput hidden accept="image/*" (change)="handleImageUpload($event)">
      </div>
    </div>

    <div class="parameter-section">
      <h3>{{'jsoncomponent.parameters'|translateTA}}</h3>

      <nz-empty *ngIf="!config.parameters?.length" nzNotFoundImage="simple"
        [nzNotFoundContent]="'jsoncomponent.noParameters'|translateTA"></nz-empty>

      <div *ngFor="let param of config.parameters; let i = index" class="parameter-block">
        <fieldset>
          <legend>{{'jsoncomponent.parameter'|translateTA}} {{'@'}}{{ param.PARNAME || ('jsoncomponent.unnamed'|translateTA) }}</legend>

          <div class="input-row">
            <div class="tem-field">
              <span class="tem-field-label">{{'jsoncomponent.paramName'|translateTA}}</span>
              <input nz-input [(ngModel)]="param.PARNAME" [placeholder]="'jsoncomponent.paramName'|translateTA" />
            </div>
            <div class="tem-field">
              <span class="tem-field-label">{{'jsoncomponent.paramType'|translateTA}}</span>
              <nz-select [(ngModel)]="param.TYPE" (ngModelChange)="onParameterTypeChange(param, $event)" nzShowSearch>
                <nz-option nzValue="F" [nzLabel]="'jsoncomponent.type.fixed'|translateTA"></nz-option>
                <nz-option nzValue="I" [nzLabel]="'jsoncomponent.type.input'|translateTA"></nz-option>
                <nz-option nzValue="D" [nzLabel]="'jsoncomponent.type.file'|translateTA"></nz-option>
                <nz-option nzValue="J" [nzLabel]="'jsoncomponent.type.json'|translateTA"></nz-option>
                <nz-option nzValue="R" [nzLabel]="'jsoncomponent.type.request'|translateTA"></nz-option>
                <nz-option nzValue="FM" [nzLabel]="'jsoncomponent.type.formula'|translateTA"></nz-option>
                <nz-option nzValue="S" [nzLabel]="'jsoncomponent.type.search'|translateTA"></nz-option>
              </nz-select>
            </div>
          </div>

          <div class="tem-field field-md" *ngIf="param.TYPE === 'F' || param.TYPE === 'J'">
            <span class="tem-field-label">{{'jsoncomponent.paramValue'|translateTA}}</span>
            <input nz-input [(ngModel)]="param.VALUE" [placeholder]="'jsoncomponent.paramValue'|translateTA" />
          </div>

          <div class="input-row" *ngIf="param.TYPE === 'S'">
            <search-input-new [(ngModel)]="param.ENTITYNAME" (onChangeData)="onEntityNameChange(param)" [searchProperties]="searchMktpDic"></search-input-new>
            <search-input-new [(ngModel)]="param.KEYFIELD" [searchProperties]="searchKeyDic" *ngIf="!hiddenKeyField || param.KEYFIELD != null"></search-input-new>
            <search-input-new [(ngModel)]="param.VALUEFIELD" [searchProperties]="searchNameDic" *ngIf="!hiddenValueField || param.VALUEFIELD != null"></search-input-new>
          </div>

          <div class="tem-field" *ngIf="param.TYPE === 'FM'">
            <span class="tem-field-label">{{'jsoncomponent.formula'|translateTA}}</span>
            <textarea nz-input rows="3" [(ngModel)]="param.FORMULA"
              [placeholder]="'jsoncomponent.formulaPlaceholder'|translateTA"></textarea>
          </div>

          <div class="service-config" *ngIf="param.TYPE === 'R' && param.requestConfig">
            <button nz-button nzShape="circle" type="button" nz-tooltip
              [nzTooltipTitle]="'jsoncomponent.configureRequest'|translateTA" (click)="openRequestConfig(param)">
              <nz-icon nzType="setting" />
            </button>
            <span>{{'jsoncomponent.service'|translateTA}}: {{ param.requestConfig.serviceName }}</span>
          </div>

          <button nz-button nzDanger type="button" class="block-action" (click)="config.parameters.splice(i, 1)">
            <nz-icon nzType="delete" />{{'jsoncomponent.remove'|translateTA}}
          </button>
        </fieldset>
      </div>

      <button nz-button nzType="dashed" type="button" class="block-action" (click)="addParameter()">
        <nz-icon nzType="plus" />{{'jsoncomponent.addParameter'|translateTA}}
      </button>
    </div>

    <div class="table-section">
      <h3>{{'jsoncomponent.tables'|translateTA}}</h3>
      <ng-container *ngTemplateOutlet="tableTemplate; context: { $implicit: config.config, level: 0 }"></ng-container>
    </div>

    <ng-template #tableTemplate let-tables let-level="level">
      <div *ngFor="let table of tables" class="table-row" [class.table-row-child]="level > 0" [style.marginLeft.px]="level * 20">
        <div class="table-header input-row">
          <div class="tem-field">
            <span class="tem-field-label">{{'jsoncomponent.tableName'|translateTA}}</span>
            <input nz-input [(ngModel)]="table.NAME" [placeholder]="'jsoncomponent.tableName'|translateTA">
          </div>
          <div class="tem-field">
            <span class="tem-field-label">{{'jsoncomponent.dataorigFormula'|translateTA}}</span>
            <nz-input-group [nzSuffix]="dataorigSuffix">
              <input nz-input [(ngModel)]="table.DATAORIG" [placeholder]="'jsoncomponent.dataorigPlaceholder'|translateTA">
            </nz-input-group>
            <ng-template #dataorigSuffix>
              <nz-icon nzType="edit" class="field-action" nz-tooltip
                [nzTooltipTitle]="'jsoncomponent.editFormula'|translateTA" (click)="openEditFormula(table, 'D')" />
            </ng-template>
          </div>
          <div class="tem-field">
            <span class="tem-field-label">{{'jsoncomponent.filter'|translateTA}}</span>
            <input nz-input [(ngModel)]="table.FILTER" [placeholder]="'jsoncomponent.filterPlaceholder'|translateTA">
          </div>
        </div>

        <div class="table-actions">
          <button nz-button nzType="dashed" type="button" (click)="addColumn(table)">
            <nz-icon nzType="plus" />{{'jsoncomponent.addColumn'|translateTA}}
          </button>
          <button nz-button nzType="dashed" type="button" (click)="addTable(table)">
            <nz-icon nzType="plus" />{{'jsoncomponent.addChildTable'|translateTA}}
          </button>
          <button nz-button nzDanger type="button" nz-tooltip
            [nzTooltipTitle]="'jsoncomponent.removeTable'|translateTA" (click)="removeTable(tables, table)">
            <nz-icon nzType="delete" />
          </button>
        </div>

        <div class="columns-section">
          <h4>{{'jsoncomponent.columns'|translateTA}}</h4>
          <div *ngFor="let column of table.COLUMNS" class="column-row input-row">
            <div class="tem-field">
              <span class="tem-field-label">{{'jsoncomponent.columnName'|translateTA}}</span>
              <input nz-input [(ngModel)]="column.columnName" [placeholder]="'jsoncomponent.columnName'|translateTA">
            </div>
            <div class="tem-field">
              <span class="tem-field-label">{{'jsoncomponent.columnType'|translateTA}}</span>
              <nz-select [(ngModel)]="column.type">
                <nz-option nzValue="PARAM" [nzLabel]="'jsoncomponent.colType.param'|translateTA"></nz-option>
                <nz-option nzValue="FORMULA" [nzLabel]="'jsoncomponent.colType.formula'|translateTA"></nz-option>
                <nz-option nzValue="FIXED" [nzLabel]="'jsoncomponent.colType.fixed'|translateTA"></nz-option>
                <nz-option nzValue="JSON" [nzLabel]="'jsoncomponent.colType.json'|translateTA"></nz-option>
              </nz-select>
            </div>
            <div class="tem-field">
              <span class="tem-field-label">{{'jsoncomponent.columnValue'|translateTA}}</span>
              <nz-input-group [nzSuffix]="columnSuffix">
                <input nz-input [(ngModel)]="column.value" [placeholder]="'jsoncomponent.columnValuePlaceholder'|translateTA">
              </nz-input-group>
              <ng-template #columnSuffix>
                <nz-icon nzType="edit" class="field-action" nz-tooltip
                  [nzTooltipTitle]="'jsoncomponent.editFormula'|translateTA" (click)="openEditFormula(column, 'V')" />
              </ng-template>
            </div>
            <button nz-button nzDanger type="button" class="column-remove" nz-tooltip
              [nzTooltipTitle]="'jsoncomponent.removeColumn'|translateTA" (click)="removeColumn(table, column)">
              <nz-icon nzType="delete" />
            </button>
          </div>
        </div>

        <div class="child-tables">
          <h4 *ngIf="table.CHILD?.length">{{'jsoncomponent.childTables'|translateTA}}</h4>
          <ng-container *ngTemplateOutlet="tableTemplate; context: { $implicit: table.CHILD, level: level + 1 }"></ng-container>
        </div>
      </div>
    </ng-template>

    <div class="json-preview">
      <h3>{{'jsoncomponent.generatedJson'|translateTA}}</h3>
      <div class="json-buttons">
        <button nz-button type="button" (click)="enableJsonEdit()">
          <nz-icon nzType="edit" />{{'jsoncomponent.editJson'|translateTA}}
        </button>
        <button nz-button type="button" (click)="copyJson(true)">
          <nz-icon nzType="copy" />{{'jsoncomponent.copyJson'|translateTA}}
        </button>
      </div>

      <div *ngIf="!editingJson">
        <pre>{{ getFormattedJSON() }}</pre>
      </div>

      <div *ngIf="editingJson">
        <div class="tem-field json-editor-field">
          <textarea nz-input rows="20" [(ngModel)]="jsonEditorText"
            [placeholder]="'jsoncomponent.editJsonPlaceholder'|translateTA"></textarea>
        </div>

        <div class="json-actions">
          <button nz-button type="button" (click)="cancelJsonEdit()">{{'cancel'|translateTA}}</button>
          <button nz-button nzType="primary" type="button" (click)="applyJsonEdit()">{{'jsoncomponent.apply'|translateTA}}</button>
        </div>

        <nz-alert *ngIf="jsonParseError" nzType="error" class="json-error"
          [nzMessage]="('jsoncomponent.invalidJson'|translateTA) + ': ' + jsonParseError"></nz-alert>
      </div>
    </div>

  </div>
</div>

<div class="dialog-actions">
  <button nz-button type="button" (click)="dialogRef.close()">{{'cancel'|translateTA}}</button>
  <button nz-button nzType="primary" type="button"
    (click)="dialogRef.close({config: config, file: selectedFile, name: configName})">{{'save'|translateTA}}</button>
</div>
